import { buildEntitiesFromWorkflowPrompt } from '@/ai/prompts'
import { fetchJsonResponse, streamJsonResponses } from '@/ai/api'

export const generateEntitiesFromWorkflow = async ({
  workflow,
  cardTypes,
  stream = false,
  onChunkReceived,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }
  if (stream && typeof onChunkReceived !== 'function') {
    return null
  }

  const messages = buildEntitiesFromWorkflowPrompt({ workflow, cardTypes, stream })

  if (stream) {
    return await streamJsonResponses({
      messages,
      useCase: 'entities',
      aiVersion: workflow.aiVersion,
      onChunkReceived,
      signal: abortController?.signal
    })
  } else {
    const response = await fetchJsonResponse({
      messages,
      useCase: 'entities',
      aiVersion: workflow.aiVersion,
      signal: abortController?.signal
    })

    return response || null
  }
}
